const regex = (v: any, r: any) => {
	return empty(v) ? null : r.exec(v) !== null
}

const empty = (s: any) => {
	return s === "" || s === undefined || s === null
}

const number = (v: any) => {
	const r = /^\d+$/gm
	return empty(v) ? true : regex(v, r)
}

const validator = () => {
	const strings = {
		number: (field: string) => `The ${field} field must be a number`,
		equal: (field: string) => `The ${field} field is incorrect`,
		email: (field: string) => `The ${field} field is incorrect`,
		mobile: (field: string) => `The ${field} field is incorrect`,
		tel: (field: string) => `The ${field} field is incorrect`,
		length: (field: string, n: any) => `The ${field} field must be ${n} characters`,
		minLength: (field: string, n: any) => `The ${field} field must be at least ${n} characters long`,
		maxLength: (field: string, n: any) => `The ${field} field must be at most ${n} characters long`,
		min: (field: string, n: any) => `The ${field} field must be greater than ${n}`,
		max: (field: string, n: any) => `The ${field} field must be less than ${n}`,
		valid: (field: string) => `The ${field} field can't be empty`
	}

	return {
		number,
		email(v: any) {
			const r = /^.+@.+\..+$/gm
			return empty(v) ? true : regex(v, r)
		},
		equal(v: any, t: any) {
			return empty(v) ? true : v === t
		},
		mobile(v: any) {
			const r = /^[0+]\d{10,17}$/gm
			return empty(v) ? true : regex(v, r)
		},
		tel(v: any) {
			const r = /^0\d{4,10}$/gm
			return empty(v) ? true : regex(v, r)
		},
		minLength(v: any, t: any) {
			return empty(v) ? true : v.length >= t
		},
		maxLength(v: any, t: any) {
			return empty(v) ? true : v.length <= t
		},
		length(v: any, t: any) {
			const r = new RegExp(`^.{${t}}$`, "gm")
			return empty(v) ? true : regex(v, r)
		},
		max(v: any, t: any) {
			const n = parseInt(v)
			return empty(v) ? true : number(v) && n <= t
		},
		min(v: any, t: any) {
			const n = parseInt(v)
			return empty(v) ? true : number(v) && n >= t
		},
		valid(v: any) {
			return empty(v) ? null : true
		},
		validate(value: any, field: string, validations: string): string[] {
			const a: string[] = []
			validations.split("|").forEach((o) => {
				const [k, n] = [
					...o
						.replace("]", "")
						.split("[")
						.filter((t) => t),
					null,
					null
				]
				// @ts-ignore
				const f = validator[k]
				if (f && f(value, n) !== true) {
					// @ts-ignore
					const f2 = strings[k]
					a.push(f2(field, n))
				}
			})
			return a
		}
	}
}

export default validator
